import UniqaLogo from "src/assets/images/brands/uniqa.png";
import SavaLogo from "src/assets/images/brands/sava.png";
import GraweLogo from "src/assets/images/brands/grawe.svg";
import AllianzLogo from "src/assets/images/brands/allianz.svg";

export const BrandLogos = () => [
  {
    name: "uniqa",
    logo: UniqaLogo,
  },
  {
    name: "sava",
    logo: SavaLogo,
  },
  {
    name: "grawe",
    logo: GraweLogo,
  },
  {
    name: "allianz",
    logo: AllianzLogo,
  }
]

export type BrandName = ReturnType<typeof BrandLogos>[number]["name"];

export const getBrandLogo = (brandName: BrandName) => {
  const brandLogo = BrandLogos().find((brand) => brand.name === brandName);
  return brandLogo?.logo;
};